import { formatWholeNumber } from '@cmd/ui-utilities';
export const getVehicleCountMessage = (intl, count) => intl.formatMessage({
    id: 'VEHICLE_COUNT',
    defaultMessage: '{count} Vehicle{plural}',
}, {
    count: formatWholeNumber(count),
    plural: count === 1 ? '' : 's',
});
